import { gql } from '@apollo/client';

export const GET_DELIVERY_DRIVER_ACCOUNTS_FOR_SELECT = gql`
  query GetDeliveryDriverAccountsForSelect($name: String, $phone: String) {
    getDeliveryDriverAccountsForSelect(name: $name, phone: $phone) {
      id
      name
      phone
    }
  }
`;

export interface DeliveryDriverAccount {
  id: string;
  name: string;
  phone: string | null;
}

export interface GetDeliveryDriverAccountsForSelectResponse {
  getDeliveryDriverAccountsForSelect: DeliveryDriverAccount[];
}

